var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',_vm._b({style:({
  '--color': _vm.color,
  '--bg--color': _vm.bgColor,
}),on:{"change":params=>_vm.$emit('change',params)},model:{value:(_vm.values),callback:function ($$v) {_vm.values=$$v},expression:"values"}},'el-select',_vm.$attrs,false),_vm._l((_vm.list),function(item){return _c('el-option',{key:item.选中数据,attrs:{"label":item.显示数据,"value":item.选中数据}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }